export default __webpack_public_path__ + "static/blog-bg-5bb5321af705d41523f249316c5fa091.png";